<template>
  <div>
    <Toolbar :handle-submit="onSendForm" :handle-reset="resetForm">
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-bug-check</v-icon>{{$t('qualitycheck.qualitycheck.check')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <QualityCheckForm ref="createForm" :values="item" :initproduct="initProduct" :errors="violations" />
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import QualityCheckForm from '../../components/qualitycheck/Form';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import CreateMixin from '../../mixins/CreateMixin';

const servicePrefix = 'QualityCheck';

const { mapFields } = createHelpers({
  getterType: 'qualitycheck/getField',
  mutationType: 'qualitycheck/updateField'
});

export default {
  name: 'QualityCheckCreate',
  servicePrefix,
  mixins: [CreateMixin],
  components: {
    Loading,
    Toolbar,
    QualityCheckForm
  },
  data() {
    return {
      item: {
        'product' : this.$route.params.parent
      },
      initProduct : this.$route.params.parent
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations'])
  },
  methods: {
    ...mapActions('qualitycheck', ['create', 'reset'])
  }
};
</script>
